import type { TruckDeviceOutcome } from '../../../../integrations/features/gps/public/use-truck-device';

/** The truck form's values: the truck's own fields, plus the picked GPS device, which is saved by its own call after the truck (gitaumoses4/chukua#422). */
export type WithDevice<T> = T & { device?: string };

export function splitDevice<T extends object>(values: WithDevice<T>): { input: T; device: string | undefined } {
  const { device, ...input } = values;
  return { input: input as unknown as T, device };
}

export interface TruckSavedNotice {
  kind: 'success' | 'info' | 'error';
  message: string;
}

/** The truck is already saved by now; this says how the device call went, because the two are separate requests and can part ways. */
export function truckSavedNotice(saved: string, outcome: TruckDeviceOutcome): TruckSavedNotice {
  switch (outcome) {
    case 'set':
      return { kind: 'success', message: `${saved}, GPS device set` };
    case 'cleared':
      return { kind: 'success', message: `${saved}, GPS device removed` };
    case 'taken':
      return { kind: 'info', message: `${saved}, but that GPS device was taken by another truck` };
    case 'failed':
      return { kind: 'error', message: `${saved}, but the GPS device could not be changed` };
    default:
      return { kind: 'success', message: saved };
  }
}
